import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _Notifications;
import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import PluginOutlet from "discourse/components/plugin-outlet";
import { addExtraUserClasses, renderAvatar } from "discourse/helpers/user-avatar";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import UserTip from "../../user-tip";
import UserStatusBubble from "./user-status-bubble";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let Notifications = (_class = (_Notifications = class Notifications extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor2, this);
    _defineProperty(this, "avatarSize", "medium");
  }
  get avatar() {
    const avatarAttrs1 = addExtraUserClasses(this.currentUser, {});
    return htmlSafe(renderAvatar(this.currentUser, {
      imageSize: this.avatarSize,
      title: i18n("user.avatar.header_title"),
      template: this.currentUser.avatar_template,
      username: this.currentUser.username,
      name: this.siteSettings.enable_names && this.currentUser.name,
      ...avatarAttrs1
    }));
  }
  get _shouldHighlightAvatar() {
    return !this.currentUser.read_first_notification && !this.currentUser.enforcedSecondFactor && !this.args.active;
  }
  get isInDoNotDisturb() {
    return this.currentUser.isInDoNotDisturb();
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <PluginOutlet @name="user-dropdown-notifications__before" />
    {{this.avatar}}

    {{#if this._shouldHighlightAvatar}}
      <UserTip
        @id="first_notification"
        @triggerSelector=".header-dropdown-toggle.current-user"
        @placement="bottom-end"
        @titleText={{i18n "user_tips.first_notification.title"}}
        @contentText={{i18n "user_tips.first_notification.content"}}
        @showSkipButton={{true}}
      />
    {{/if}}

    {{#if this.currentUser.status}}
      <UserStatusBubble
        @timezone={{this.this.currentUser.user_option.timezone}}
        @status={{this.currentUser.status}}
      />
    {{/if}}

    {{#if this.isInDoNotDisturb}}
      <div class="do-not-disturb-background">{{icon "discourse-dnd"}}</div>
    {{else}}
      {{#if this.currentUser.new_personal_messages_notifications_count}}
        <a
          href="#"
          class="badge-notification with-icon new-pms"
          title={{i18n
            "notifications.tooltip.new_message_notification"
            (hash
              count=this.currentUser.new_personal_messages_notifications_count
            )
          }}
          aria-label={{i18n
            "notifications.tooltip.new_message_notification"
            (hash
              count=this.currentUser.new_personal_messages_notifications_count
            )
          }}
        >
          {{icon "envelope"}}
        </a>
      {{else if this.currentUser.unseen_reviewable_count}}
        <a
          href="#"
          class="badge-notification with-icon new-reviewables"
          title={{i18n
            "notifications.tooltip.new_reviewable"
            (hash count=this.currentUser.unseen_reviewable_count)
          }}
          aria-label={{i18n
            "notifications.tooltip.new_reviewable"
            (hash count=this.currentUser.unseen_reviewable_count)
          }}
        >
          {{icon "flag"}}
        </a>
      {{else if this.currentUser.all_unread_notifications_count}}
        <a
          href="#"
          class="badge-notification unread-notifications"
          title={{i18n
            "notifications.tooltip.regular"
            (hash count=this.currentUser.all_unread_notifications_count)
          }}
          aria-label={{i18n
            "user.notifications"
            (hash count=this.currentUser.all_unread_notifications_count)
          }}
        >
          {{this.currentUser.all_unread_notifications_count}}
        </a>
      {{/if}}
    {{/if}}
    <PluginOutlet @name="user-dropdown-notifications__after" />
  
*/
{
  "id": "sq3tBnKT",
  "block": "[[[1,\"\\n    \"],[8,[32,0],null,[[\"@name\"],[\"user-dropdown-notifications__before\"]],null],[1,\"\\n    \"],[1,[30,0,[\"avatar\"]]],[1,\"\\n\\n\"],[41,[30,0,[\"_shouldHighlightAvatar\"]],[[[1,\"      \"],[8,[32,1],null,[[\"@id\",\"@triggerSelector\",\"@placement\",\"@titleText\",\"@contentText\",\"@showSkipButton\"],[\"first_notification\",\".header-dropdown-toggle.current-user\",\"bottom-end\",[28,[32,2],[\"user_tips.first_notification.title\"],null],[28,[32,2],[\"user_tips.first_notification.content\"],null],true]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"currentUser\",\"status\"]],[[[1,\"      \"],[8,[32,3],null,[[\"@timezone\",\"@status\"],[[30,0,[\"currentUser\",\"user_option\",\"timezone\"]],[30,0,[\"currentUser\",\"status\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isInDoNotDisturb\"]],[[[1,\"      \"],[10,0],[14,0,\"do-not-disturb-background\"],[12],[1,[28,[32,4],[\"discourse-dnd\"],null]],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"currentUser\",\"new_personal_messages_notifications_count\"]],[[[1,\"        \"],[10,3],[14,6,\"#\"],[14,0,\"badge-notification with-icon new-pms\"],[15,\"title\",[28,[32,2],[\"notifications.tooltip.new_message_notification\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"new_personal_messages_notifications_count\"]]]]]],null]],[15,\"aria-label\",[28,[32,2],[\"notifications.tooltip.new_message_notification\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"new_personal_messages_notifications_count\"]]]]]],null]],[12],[1,\"\\n          \"],[1,[28,[32,4],[\"envelope\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"currentUser\",\"unseen_reviewable_count\"]],[[[1,\"        \"],[10,3],[14,6,\"#\"],[14,0,\"badge-notification with-icon new-reviewables\"],[15,\"title\",[28,[32,2],[\"notifications.tooltip.new_reviewable\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"unseen_reviewable_count\"]]]]]],null]],[15,\"aria-label\",[28,[32,2],[\"notifications.tooltip.new_reviewable\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"unseen_reviewable_count\"]]]]]],null]],[12],[1,\"\\n          \"],[1,[28,[32,4],[\"flag\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"currentUser\",\"all_unread_notifications_count\"]],[[[1,\"        \"],[10,3],[14,6,\"#\"],[14,0,\"badge-notification unread-notifications\"],[15,\"title\",[28,[32,2],[\"notifications.tooltip.regular\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"all_unread_notifications_count\"]]]]]],null]],[15,\"aria-label\",[28,[32,2],[\"user.notifications\",[28,[32,5],null,[[\"count\"],[[30,0,[\"currentUser\",\"all_unread_notifications_count\"]]]]]],null]],[12],[1,\"\\n          \"],[1,[30,0,[\"currentUser\",\"all_unread_notifications_count\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]],null]],[]]]],[]]]],[]]],[1,\"    \"],[8,[32,0],null,[[\"@name\"],[\"user-dropdown-notifications__after\"]],null],[1,\"\\n  \"]],[],false,[\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/header/user-dropdown/notifications.js",
  "scope": () => [PluginOutlet, UserTip, i18n, UserStatusBubble, icon, hash],
  "isStrictMode": true
}), _Notifications), _Notifications), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { Notifications as default };